export default [
  {
    path: '/vzliveplayer',
    meta: {
      title: '',
      whiteList: true
    },
    component: () =>
      import(
        /* webpackChunkName: "vzanliveplayer" */ '@/pages/vzanliveplayer/index.vue'
      )
  }
]
